import React from "react";
import Tab1Img1 from "../Assets/img/mobile-app-features/tab-1.png";
import Tab1Img2 from "../Assets/img/mobile-app-features/tab-2.png";
import Tab1Img3 from "../Assets/img/mobile-app-features/tab-3.png";
import Tab1Img4 from "../Assets/img/mobile-app-features/tab-4.png";
import Tab1Img5 from "../Assets/img/mobile-app-features/tab-5.png";
import Tab1Img6 from "../Assets/img/mobile-app-features/tab-6.png";

const MobileAppFeatures = () => {
  return (
    <>
      <section className="mobileapp-feature-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="tab-content" id="nav-tabContent">
                {/* <!-- Tab One --> */}
                <div
                  className="tab-pane fade show active"
                  role="tabpanel"
                  id="tab11"
                >
                  <div className="mobileapp-image">
                    <img src={Tab1Img1} alt="#" />
                  </div>
                </div>
                <div className="tab-pane fade" role="tabpanel" id="tab22">
                  <div className="mobileapp-image">
                    <img src={Tab1Img2} alt="#" />
                  </div>
                </div>
                <div className="tab-pane fade" role="tabpanel" id="tab33">
                  <div className="mobileapp-image">
                    <img src={Tab1Img3} alt="#" />
                  </div>
                </div>
                <div className="tab-pane fade" role="tabpanel" id="tab44">
                  <div className="mobileapp-image">
                    <img src={Tab1Img4} alt="#" />
                  </div>
                </div>
                <div className="tab-pane fade" role="tabpanel" id="tab55">
                  <div className="mobileapp-image">
                    <img src={Tab1Img5} alt="#" />
                  </div>
                </div>
                <div className="tab-pane fade" role="tabpanel" id="tab66">
                  <div className="mobileapp-image">
                    <img src={Tab1Img6} alt="#" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="mobileapp-feature-content">
                <ul
                  className="menu-tab nav nav-tabs menu-tab list-group"
                  data-toggle="tab-mobile-app"
                  id="list-tab"
                  role="tablist"
                >
                  <li className="nav-item single-feature-list">
                    <a
                      className="list-group-item nav-item active"
                      data-bs-toggle="list"
                      href="#tab11"
                      role="tab"
                    >
                      <div className="single-feature-c">
                        <span className="feature-number border-line">1</span>
                        <div className="s-f-content-main">
                          <h4 className="f-title">
                            Real Time Traffic Monitoring
                          </h4>
                          <p>
                            Users can check real-time upload & download data.
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="nav-item single-feature-list">
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab22"
                      role="tab"
                    >
                      <div className="single-feature-c">
                        <span className="feature-number border-line">2</span>
                        <div className="s-f-content-main">
                          <h4 className="f-title">Online Payment System</h4>
                          <p>
                            Users can pay internet bill through MFS, Cards and
                            others.
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="nav-item single-feature-list">
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab33"
                      role="tab"
                    >
                      <div className="single-feature-c">
                        <span className="feature-number border-line">3</span>
                        <div className="s-f-content-main">
                          <h4 className="f-title">Support & Ticketing</h4>
                          <p>
                            Users can notify their problems from their own
                            portal.
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="nav-item single-feature-list">
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab44"
                      role="tab"
                    >
                      <div className="single-feature-c">
                        <span className="feature-number border-line">4</span>
                        <div className="s-f-content-main">
                          <h4 className="f-title">Package Change Request</h4>
                          <p>
                            Upgrade or downgrade! Now it's easier to change the
                            package.
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="nav-item single-feature-list">
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab55"
                      role="tab"
                    >
                      <div className="single-feature-c">
                        <span className="feature-number border-line">5</span>
                        <div className="s-f-content-main">
                          <h4 className="f-title">Router Connectivity Test</h4>
                          <p>Users can test their router connectivity.</p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="nav-item single-feature-list">
                    <a
                      className="list-group-item nav-item"
                      data-bs-toggle="list"
                      href="#tab66"
                      role="tab"
                    >
                      <div className="single-feature-c">
                        <span className="feature-number border-line">6</span>
                        <div className="s-f-content-main">
                          <h4 className="f-title">News & Event</h4>
                          <p> Users can read all the news and events.</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileAppFeatures;
